import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import {
  getSellerInstantRequests,
  getSellerPendingRequests,
  getSellerAcceptedRequests,
  submitCounterOffer,
  markCounterOfferNotAvailable,
  cancelCounterOffer,
  modifyCounterOffer,
  requestCallToBuyer,
  getIrmFilterList,
  getSellerId
} from '../../utils/api';
import { Modal, Input, Toggle, SearchableLocationDropdown }
  from '../../components/common';
import { showBrowserNotification } from '../../utils/notifications';
import { showSuccess, showError } from '../../utils/toast';
import { DashboardLayout, DataTable } from '../../components/layout';
import '../dashboard/Dashboard.css';


const InstantRequest = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [activeTab, setActiveTab] = useState('new');
  const [showAddPrice, setShowAddPrice] = useState(false);
  const [showModifyPrice, setShowModifyPrice] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  // const irmFilterConfig = [
  //   { key: "grade", label: "Grade", api: (id) => getIrmFilterList("grade") },
  //   { key: "process", label: "Process", api: (id) => getIrmFilterList("process") },
  //   { key: "brand", label: "Brand", api: (id) => getIrmFilterList("brand") },
  //   { key: "grade_code", label: "Grade Code", api: (id) => getIrmFilterList("grade_code") },
  //   { key: "delivery_location", label: "Delivery Location", api: (id) => getIrmFilterList("delivery_location") }
  // ];

  const [tabFilters, setTabFilters] = useState({
    new: {
      grade: null,
      process: null,
      brand: null,
      grade_code: null,
      delivery_location: null
    },
    pending: {
      grade: null,
      process: null,
      brand: null,
      grade_code: null,
      delivery_location: null
    },
    accepted: {
      grade: null,
      process: null,
      brand: null,
      grade_code: null,
      delivery_location: null
    }
  });


  const [filterOptions, setFilterOptions] = useState({
    grade: [],
    process: [],
    brand: [],
    grade_code: [],
    delivery_location: []
  });

  const [tabCounts, setTabCounts] = useState({
    new: 0,
    pending: 0,
    accepted: 0
  });


  useEffect(() => {
    if (!showFilterPopup) return;

    const loadFilters = async () => {
      const types = [
        'grade',
        'process',
        'brand',
        'grade_code',
        'delivery_location'
      ];

      try {


        const results = await Promise.all(
          types.map(type => getIrmFilterList(type))
        );

        setFilterOptions({
          grade: results[0]?.data || [],
          process: results[1]?.data || [],
          brand: results[2]?.data || [],
          grade_code: results[3]?.data || [],
          delivery_location: results[4]?.data || []
        });
      } catch (err) {
        console.error('Failed to load filters', err);
      }
    };
    loadFilters();
  }, [showFilterPopup]);



  const openAddPriceModal = (item) => {
    setSelectedRequest(item);
    setShowAddPrice(true);
  };

  const openModifyOfferModal = (item) => {
    setSelectedRequest(item);
    setShowModifyPrice(true);
  };


  const normalizeRequest = (item) => {
    return {
      request_id: item.id || item.irm_request_id,

      product_name: [
        item.grade_name,
        item.process_name,
        item.brand_name,
        item.grade_code_name
      ].filter(Boolean).join(' '),

      material_location: [
        item.city_name,
        item.state_short_name,
        item.country_name
      ].filter(Boolean).join(', ') || '—',

      grade_code_mfi_value: item.grade_code_mfi_value,
      quantity: `${item.qty || item.seller_qty} MT`,

      request_received: new Date(item.created_at).toLocaleString(),

      // keep raw object if needed later
      raw: item
    };
  };


  useEffect(() => {
    loadTabCounts();
  }, []);



  const loadRequests = async () => {
    setLoading(true);

    try {
      const sellerId = getSellerId();
      const activeFilters = tabFilters[activeTab]; // 🔥 key fix
      let response;

      if (activeTab === 'new') {
        response = await getSellerInstantRequests(
          sellerId,
          currentPage,
          entriesPerPage,
          activeFilters
        );
      }

      if (activeTab === 'pending') {
        response = await getSellerPendingRequests(
          sellerId,
          currentPage,
          entriesPerPage,
          activeFilters
        );
      }

      if (activeTab === 'accepted') {
        response = await getSellerAcceptedRequests(
          sellerId,
          currentPage,
          entriesPerPage,
          activeFilters
        );
      }

      const list = Array.isArray(response?.data) ? response.data : [];
      setRequests(list.map(normalizeRequest));
    } catch (error) {
      console.error(error);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadRequests();
  }, [activeTab, currentPage, tabFilters, reloadKey]);





  const ModifyOfferModal = ({ open, onClose, request, loadRequests }) => {
    const [form, setForm] = useState({
      material_location_id: request?.raw?.material_location_id || '',
      seller_qty: request?.raw?.seller_qty || '',
      seller_price: request?.raw?.seller_price || ''
    });
    useEffect(() => {
      if (request?.raw) {
        setForm({
          material_location_id: request.raw.material_location_id || '',
          seller_qty: request.raw.seller_qty || '',
          seller_price: request.raw.seller_price || ''
        });
      }
    }, [request]);

    const handleSubmit = async () => {
      try {
        const res = await modifyCounterOffer({
          sellerId: getSellerId(),
          irmRequestId: request.raw.id,
          qty: parseFloat(form.seller_qty),
          price: parseFloat(form.seller_price),
          material_location_id: form.material_location_id
        });

        showSuccess(res?.message || 'Counter offer modified successfully');

        onClose();

        setRequests(prev =>
          prev.filter(r => r.raw.id !== request.raw.id)
        );

        // 🔥 force list refresh
        setReloadKey(prev => prev + 1);

        // 🔥 refresh tab counts
        loadTabCounts();

      } catch (err) {
        console.error(err);
        showError(err?.message || 'Failed to modify counter offer');
      }
    };


    return (
      <Modal open={open} onClose={onClose} title="Modify Offer">
        <SearchableLocationDropdown
          value={form.material_location_id}
          onChange={(id) =>
            setForm({ ...form, material_location_id: id })
          }
        />

        <Input
          label="Quantity"
          suffix="MT"
          type="number"
          value={form.seller_qty}
          onChange={(e) =>
            setForm({ ...form, seller_qty: e.target.value })
          }
        />

        <Input
          label="Price"
          suffix="/kg"
          type="number"
          step="0.25"
          value={form.seller_price}
          onChange={(e) =>
            setForm({ ...form, seller_price: e.target.value })
          }
        />

        <button className="btn-primary full" onClick={handleSubmit}>
          Update Offer
        </button>
      </Modal>
    );
  };


  const renderFilterSelect = (label, key) => {
    const options = filterOptions[key].map(opt => ({
      value: opt.id,
      label: opt.name
    }));

    return (
      <div className="filter-group">
        <label>{label}</label>

        <Select
          options={options}
          isClearable
          isSearchable
          placeholder={`Select ${label}`}
          value={
            tabFilters[activeTab][key]
              ? {
                value: tabFilters[activeTab][key].id,
                label: tabFilters[activeTab][key].name
              }
              : null
          }
          onChange={(selected) => {
            setTabFilters(prev => ({
              ...prev,
              [activeTab]: {
                ...prev[activeTab],
                [key]: selected
                  ? { id: selected.value, name: selected.label }
                  : null
              }
            }));
          }}
        />
      </div>
    );
  };





  const AddPriceModal = ({ open, onClose, request }) => {

    const [form, setForm] = useState({
      material_location_id: '',
      seller_qty: '',
      seller_price: '',
      is_public: false
    });

    const handleSubmit = async () => {
      try {
        const res = await submitCounterOffer({
          sellerId: getSellerId(),
          irmRequestId: request.raw.id,
          qty: parseFloat(form.seller_qty),
          price: parseFloat(form.seller_price),
          material_location_id: form.material_location_id,
          offer_availability: form.is_public
        });

        // ✅ success toast
        showSuccess(res?.message || 'Counter offer submitted successfully');

        onClose();

        // 🔥 force list refresh
        setReloadKey(prev => prev + 1);
        console.log("here");

        // 🔥 refresh tab counts
        loadTabCounts();
        loadRequests();
      } catch (err) {
        console.error(err);

        // ❌ error toast
        showError(
          err?.message || 'Failed to submit counter offer'
        );
      }
    };

    return (
      <Modal open={open} onClose={onClose} title="Add Price">
        <SearchableLocationDropdown
          value={form.material_location_id}
          onChange={(id) =>
            setForm({ ...form, material_location_id: id })
          }
        />

        <Input
          label="Quantity"
          suffix="MT"
          value={form.seller_qty}
          type="number"
          step="1"
          onChange={(e) =>
            setForm({ ...form, seller_qty: e.target.value })
          }
        />

        <Input
          label="Price"
          suffix="/kg"
          value={form.seller_price}
          step="0.25"
          type="number"
          onChange={(e) =>
            setForm({ ...form, seller_price: e.target.value })
          }
        />

        <Toggle
          label="Make this offer available to all other buyers on BSB Polymer Trade App"
          checked={form.is_public}
          onChange={(val) =>
            setForm({ ...form, is_public: val })
          }
        />

        <button className="btn-primary full" onClick={handleSubmit}>
          Submit Offer
        </button>
      </Modal>
    );
  };

  const markNotAvailableAPI = async (requestId) => {
    try {

      if (!window.confirm('Are you sure you want to mark this request as not available?')) {
        return;
      }
      const sellerId = getSellerId();

      const res = await markCounterOfferNotAvailable(
        sellerId,
        requestId
      );

      // ✅ success toast
      showSuccess(res?.message || 'Marked as not available');

      return true;
    } catch (error) {
      console.error('Not available error:', error);

      // ❌ error toast
      showError(
        error?.message || 'Failed to mark as not available'
      );

      return false;
    }
  };

  const cancelOfferAPI = async (offerId) => {
    try {
      const sellerId = getSellerId();

      const res = await cancelCounterOffer(sellerId, offerId);


      // 🔥 refresh tab counts
      loadTabCounts();
      // ✅ success toast
      showSuccess(res?.message || 'Counter offer cancelled successfully');

      return true;
    } catch (error) {
      console.error('Cancel offer error:', error);

      // ❌ error toast
      showError(error?.message || 'Failed to cancel counter offer');

      return false;
    }
  };

  // 🔔 Browser notification
  // showBrowserNotification({
  //   title: 'Call Request Sent 📞',
  //   body: 'Buyer has been notified. They may contact you shortly.',
  //   onClick: () => {
  //     window.location.href = '/seller/requests';
  //   }
  // });

  const requestCallAPI = async (offerId) => {
    try {
      if (!window.confirm('Send call request to buyer?')) return;


      const sellerId = getSellerId();

      const res = await requestCallToBuyer(
        sellerId,
        offerId
      );

      // ✅ success toast
      showSuccess(res?.message || 'Call request sent successfully');

      // 🔔 Browser notification
      showBrowserNotification({
        title: 'Call Request Sent 📞',
        body: 'Buyer has been notified. They may contact you shortly.',
        onClick: () => {
          window.location.href = '/seller/requests';
        }
      });

      return true;
    } catch (error) {
      console.error('Request call error:', error);

      // ❌ error toast
      showError(
        error?.message || 'Failed to request call'
      );

      return false;
    }
  };

  // Define table columns
  const columns = [
    {
      key: 'expand',
      title: '',
      render: () => <i className="fas fa-plus expand-icon"></i>,
      className: 'expand-column'
    },
    {
      key: 'request_id',
      title: 'Request ID',
      sortable: true,
      render: (value) => (
        <a href={`/request/${value}`} className="request-id-link">
          {value}
        </a>
      )
    },
    {
      key: 'product_name',
      title: 'Product Name'
    },
    {
      key: 'material_location',
      title: 'Material Location'
    },
    {
      key: 'quantity',
      title: 'Quantity'
    },
    {
      key: 'grade_code_mfi_value',
      title: "code mfi"
    },
    {
      key: 'request_received',
      title: 'Request Received',
      render: (value) => (
        <>
          <i className="fas fa-clock time-icon"></i>
          {value}
        </>
      )
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, item) => {
        if (activeTab === 'new') {
          return (
            <div className="action-group">
              <button
                className="btn-outline"
                onClick={async () => {
                  const success = await markNotAvailableAPI(item.raw.id);
                  if (success) {
                    loadRequests();
                  }
                }}
              >
                Not Available
              </button>

              <button
                className="btn-primary"
                onClick={() => openAddPriceModal(item)}
              >
                Add Price
              </button>
            </div>
          );
        }

        if (activeTab === 'pending') {
          return (
            <div className="action-group">
              <button
                className="btn-danger-outline"
                onClick={async () => {
                  if (!window.confirm('Are you sure you want to cancel this counter offer?')) return;

                  const success = await cancelOfferAPI(item.raw.id);
                  if (success) {
                    loadRequests(); // reload list after success
                  }
                }}
              >
                Cancel Offer
              </button>

              <button
                className="btn-primary"
                onClick={() => openModifyOfferModal(item)}
              >
                Modify Offer
              </button>
            </div>
          );
        }

        if (activeTab === 'accepted') {
          return (
            <button
              className="btn-success"
              onClick={async () => {
                const success = await requestCallAPI(item.raw.id);
                if (success) {
                  loadRequests();
                }
              }}
            >
              Call Request
            </button>
          );
        }
      }
    }
  ];
  const onTabChange = (tab) => {
    if (tab === activeTab) return; // optional safety
    setActiveTab(tab);
    setCurrentPage(1); // 🔥 critical fix
  };


  // Breadcrumbs configuration
  const breadcrumbs = [
    { label: 'Seller', link: '/dashboard' },
    { label: 'Instant requests' }
  ];

  // Custom header with tabs
  const renderTabsHeader = () => (
    <div className="tabs-container">
      <button
        className={`tab-btn ${activeTab === 'new' ? 'active' : ''}`}
        onClick={() => onTabChange('new')}
      >
        New ({tabCounts.new})
      </button>

      <button
        className={`tab-btn ${activeTab === 'pending' ? 'active' : ''}`}
        onClick={() => onTabChange('pending')}
      >
        Pending ({tabCounts.pending})
      </button>

      <button
        className={`tab-btn ${activeTab === 'accepted' ? 'active' : ''}`}
        onClick={() => onTabChange('accepted')}
      >
        Accepted ({tabCounts.accepted})
      </button>
    </div>
  );


  const loadTabCounts = async () => {
    try {
      const sellerId = getSellerId();

      const [newRes, pendingRes, acceptedRes] = await Promise.all([
        getSellerInstantRequests(sellerId, 1, 100),
        getSellerPendingRequests(sellerId, 1, 100),
        getSellerAcceptedRequests(sellerId, 1, 100)
      ]);

      setTabCounts({
        new: newRes?.data?.total_count || newRes?.data?.length || 0,
        pending: pendingRes?.data?.total_count || pendingRes?.data?.length || 0,
        accepted: acceptedRes?.data?.total_count || acceptedRes?.data?.length || 0
      });

    } catch (err) {
      console.error('Failed to load tab counts', err);
    }
  };


  const EmptyState = ({ image, text }) => (
    <div className="empty-state">
      <img src={image} alt="No data" className="empty-state-image" />
      <p className="empty-state-text">{text}</p>
    </div>
  );


  const emptyStateConfig = {
    new: {
      text: 'No new request to display.',
      image: '/assets/emptynewirm.png'
    },
    pending: {
      text: 'No pending request to display.',
      image: '/assets/emptypendingirm.png'
    },
    accepted: {
      text: 'You have not accepted any request yet.',
      image: '/assets/emptyacceptedirm.png'
    }
  };



  return (

    <DashboardLayout
      breadcrumbs={breadcrumbs}
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
    >
      <div className="requests-section">
        <div className="section-header">
          {renderTabsHeader()}
        </div>
        {!loading && requests.length === 0 ? (
          <EmptyState
            image={emptyStateConfig[activeTab].image}
            text={emptyStateConfig[activeTab].text}
          />
        ) : (
          <DataTable
            title="All Requests"
            data={requests}
            columns={columns}
            loading={loading}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            showFilters={true}
            onFilterClick={() => setShowFilterPopup(true)}
            entriesPerPage={entriesPerPage}
            onEntriesPerPageChange={(value) => {
              setEntriesPerPage(value);
              setCurrentPage(1);
            }}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            emptyMessage="No requests found"
            className="requests-table"
          />)}
      </div>

      <AddPriceModal
        open={showAddPrice}
        onClose={() => setShowAddPrice(false)}
        request={selectedRequest}
      />
      {showModifyPrice && selectedRequest && (
        <ModifyOfferModal
          open={showModifyPrice}
          onClose={() => {
            setShowModifyPrice(false);
            setSelectedRequest(null);
          }}

          request={selectedRequest}
          loadRequests={loadRequests}
        />
      )}

      {showFilterPopup && (
        <div className="filter-popup-overlay" onClick={() => setShowFilterPopup(false)}>
          <div className="filter-popup" onClick={(e) => e.stopPropagation()}>
            <h3>Filters</h3>

            {renderFilterSelect('Grade', 'grade')}
            {renderFilterSelect('Process', 'process')}
            {renderFilterSelect('Brand', 'brand')}
            {renderFilterSelect('Grade Code', 'grade_code')}
            {renderFilterSelect('Delivery Location', 'delivery_location')}

            <div className="filter-actions">
              <button
                className="btn-secondary"
                onClick={() => {
                  setTabFilters(prev => ({
                    ...prev,
                    [activeTab]: {
                      grade: null,
                      process: null,
                      brand: null,
                      grade_code: null,
                      delivery_location: null
                    }
                  }));
                }}
              >
                Clear
              </button>

              <button
                className="btn-primary"
                onClick={() => {
                  setShowFilterPopup(false);
                  setCurrentPage(1);
                  loadRequests(); // 👈 API call
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}


    </DashboardLayout>
  );
};

export default InstantRequest;